<div class="app-checkbox-accordion-root">
  <div class="region-group" *ngFor="let region of regionList">
    <div class="region-header-container">
      <mat-checkbox
        class="region-header region-checkbox"
        [checked]="getRegionById(region.id)?.allCountries"
        [indeterminate]="getRegionById(region.id)?.partialSelected"
        (change)="toggleAll(region.id, $event.checked)"
        color="primary"
      ></mat-checkbox>
      <span (click)="toggleCollapse(region.id)">
        {{ region.name }}
        <nb-icon
          [@rotateIcon]="
            getRegionById(region.id)?.collapsed ? 'collapsed' : 'expanded'
          "
          icon="arrow-ios-upward-outline"
        ></nb-icon>
      </span>
    </div>

    <div
      class="country-list"
      [@accordion]
      *ngIf="getRegionById(region.id)?.collapsed"
    >
      <div *ngFor="let country of region.countries" class="nested-checkbox">
        <mat-checkbox
          class="region-checkbox"
          [checked]="isCountrySelected(region.id, country.id)"
          (change)="toggleCountrySelection(region.id, country)"
          color="primary"
        >
          {{ country.name }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
<p class="error-message" *ngIf="this.formGroup.controls['regionExceptions'].errors"> {{ 'region-exceptions-error' | transloco}} </p>
